import { render } from "./HeroiconsOutlineChartSquareBar.vue?vue&type=template&id=184849db"
const script = {}

import exportComponent from "/home/roland/vscode/yachtbroker/portal/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineChartSquareBar.vue"]])

export default __exports__